import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../components/loading/loading.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map, tap, timeout } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';

@Injectable({ providedIn: 'root' })
export class HttpService {
  httpOptions: any;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private loadingService: LoadingService,
    private translate: TranslateService,
    private keycloakService: KeycloakService,
    private config: AppConfigService
  ) { }

  endPointUrl(path: string, guest = false) {
    var config = this.config.getConfig();
    if (guest) return `${config.guestUrl}${path}`;
    return `${config.apiUrl}${path}`;
  }

  createOptions(
    partner: string,
    account: any,
    blob: boolean = false,
    form: boolean = false,
    guest = false
  ) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Cache-Control', 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0');

    if (!guest) {
      headers = headers.append('X-TUNA-PARTNER', partner);
      headers = headers.append('X-TUNA-PARTNER-ACCOUNT', account);

      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      headers = headers.append(
        'x-tuna-timezone',
        timezone ? timezone : 'Etc/GMT'
      );
      const translate = this.translate.currentLang;
      headers = headers.append(
        'x-tuna-language',
        translate ? translate : 'en-us'
      );
    }
    if (!form) {
      headers = headers.append('Content-Type', 'application/json');
    }

    this.httpOptions = {
      headers,
    };

    if (!blob) {
      return;
    }

    headers.append('responseType', 'arraybuffer');

    this.httpOptions = {
      headers,
      responseType: 'blob',
    };
  }

  createOptionsMerchant(
    partner: string,
    account: any,
    merchant: string,
    blob: boolean = false,
    form: boolean = false,
    guest = false
  ) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', '*');

    if (!guest) {
      headers = headers.append('X-TUNA-PARTNER', partner);
      headers = headers.append('X-TUNA-PARTNER-ACCOUNT', account);
      headers = headers.append('X-TUNA-MERCHANT', merchant)

      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      headers = headers.append(
        'x-tuna-timezone',
        timezone ? timezone : 'Etc/GMT'
      );
      const translate = this.translate.currentLang;
      headers = headers.append(
        'x-tuna-language',
        translate ? translate : 'en-us'
      );
    }
    if (!form) {
      headers = headers.append('Content-Type', 'application/json');
    }

    this.httpOptions = {
      headers,
    };

    if (!blob) {
      return;
    }

    headers.append('responseType', 'arraybuffer');

    this.httpOptions = {
      headers,
      responseType: 'blob',
    };
  }

  get(
    url: string,
    partner: string,
    account: string,
    useLoading = true,
    guest = false
  ): Observable<any> {
    this.startLoading(useLoading);
    this.createOptions(partner, account, false, false, guest);
    return this.httpClient
      .get(this.endPointUrl(url, guest), this.httpOptions)

      .pipe(
        map((result) => result['result']),
        finalize(() => this.stopLoading(useLoading)),
        catchError((erro) => this.handleError(erro)),
        timeout(120000)
      );
    // .map(result => result['result'])
    // .pipe(catchError(erro => this.handleError(erro)))
    // .timeout(120000)
    // .finally(() => this.stopLoading(useLoading));
  }

  getMerchant(
    url: string,
    partner: string,
    account: string,
    merchant: string,
    useLoading = true
  ): Observable<any> {
    this.startLoading(useLoading);
    this.createOptionsMerchant(partner, account, merchant);
    return this.httpClient
      .get(this.endPointUrl(url), this.httpOptions)

      .pipe(
        map((result) => result['result']),
        finalize(() => this.stopLoading(useLoading)),
        catchError((erro) => this.handleError(erro)),
        timeout(120000)
      );
    // .map(result => result['result'])
    // .pipe(catchError(erro => this.handleError(erro)))
    // .timeout(120000)
    // .finally(() => this.stopLoading(useLoading));
  }


  post(
    url: string,
    data: any,
    partner: string,
    account: string,
    useLoading = true,
    blob = false,
    form = false,
    guest = false
  ): Observable<any> {
    this.startLoading(useLoading);
    this.createOptions(partner, account, blob, form, guest);

    data = form ? data : JSON.stringify(data);
    return this.httpClient
      .post(this.endPointUrl(url, guest), data, this.httpOptions)
      .pipe(
        map((result) => result['result']),
        finalize(() => this.stopLoading(useLoading)),
        catchError((erro) => this.handleError(erro)),
        timeout(120000)
      );
    // .map(result => result['result'])
    // .pipe(catchError(erro => this.handleError(erro)))
    // .timeout(120000)
    // .finally(() => this.stopLoading(useLoading));
  }

  postMerchant(
    url: string,
    data: any,
    partner: string,
    account: string,
    merchant: string,
    useLoading = true,
    blob = false,
    form = false,
    guest = false
  ): Observable<any> {
    this.startLoading(useLoading);
    this.createOptionsMerchant(partner, account, merchant, blob, form, guest);

    data = form ? data : JSON.stringify(data);
    return this.httpClient
      .post(this.endPointUrl(url, guest), data, this.httpOptions)
      .pipe(
        map((result) => result['result']),
        finalize(() => this.stopLoading(useLoading)),
        catchError((erro) => this.handleError(erro)),
        timeout(120000)
      );
  }


  postDown(
    url: string,
    data: any,
    partner: string,
    account: string,
    useLoading = true,
    blob = false,
    form = false
  ): Observable<any> {
    this.startLoading(useLoading);
    this.createOptions(partner, account, blob, form);
    data = form ? data : JSON.stringify(data);
    return this.httpClient
      .post(this.endPointUrl(url), data, this.httpOptions)
      .pipe(
        tap((result) => result['result']),
        finalize(() => this.stopLoading(useLoading)),
        catchError((erro) => this.handleError(erro)),
        timeout(120000)
      );
    // .pipe(catchError(erro => this.handleError(erro)))
    // .timeout(120000)
    // .finally(() => this.stopLoading(useLoading));
  }

  postDownMerchant(
    url: string,
    data: any,
    partner: string,
    account: string,
    merchant: string,
    useLoading = true,
    blob = false,
    form = false
  ): Observable<any> {
    this.startLoading(useLoading);
    this.createOptionsMerchant(partner, account, merchant, blob, form);
    data = form ? data : JSON.stringify(data);
    return this.httpClient
      .post(this.endPointUrl(url), data, this.httpOptions)
      .pipe(
        tap((result) => result['result']),
        finalize(() => this.stopLoading(useLoading)),
        catchError((erro) => this.handleError(erro)),
        timeout(120000)
      );
    // .pipe(catchError(erro => this.handleError(erro)))
    // .timeout(120000)
    // .finally(() => this.stopLoading(useLoading));
  }


  handleError(response: HttpErrorResponse) {
    console.log('ERROR:', response.message);
    if (response.error instanceof ErrorEvent) {
      this.toastr.error(response.error.message);
    } else {
      if (response.status === 401) {
        console.log('deslogou 1');
        this.keycloakService.logout();
        return throwError([{ message: '' }]);
      }

      if (response.status === 403) {
        //this.toastr.error('Usuário sem permissão de acesso.');
        this.router.navigateByUrl('/');
        return throwError([{ message: '' }]);
      }

      if (response.status == 400) {
        //  this.router.navigateByUrl('/');
        response.error.result.forEach((e) => this.toastr.error(e.message));
      }
      //response.error.forEach(e => this.toastr.error(e.message));
    }
    return throwError(
      response.error || [
        { message: 'Ocorreu um erro inesperado. Tente novamente.' },
      ]
    );
  }

  startLoading(useLoading): any {
    if (useLoading) {
      this.loadingService.start();
    }
  }

  stopLoading(useLoading) {
    if (useLoading) {
      this.loadingService.stop();
    }
  }
}
